import { render, staticRenderFns } from "./Slidbar.vue?vue&type=template&id=d2515710&scoped=true"
import script from "./Slidbar.vue?vue&type=script&lang=js"
export * from "./Slidbar.vue?vue&type=script&lang=js"
import style0 from "./Slidbar.vue?vue&type=style&index=0&id=d2515710&prod&lang=less&scoped=true"
import style1 from "./Slidbar.vue?vue&type=style&index=1&id=d2515710&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2515710",
  null
  
)

export default component.exports